import { render, staticRenderFns } from "./demo_render.vue?vue&type=template&id=1b695ddf&scoped=true"
import script from "./demo_render.vue?vue&type=script&lang=js"
export * from "./demo_render.vue?vue&type=script&lang=js"
import style0 from "./demo_render.vue?vue&type=style&index=0&id=1b695ddf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b695ddf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b695ddf')) {
      api.createRecord('1b695ddf', component.options)
    } else {
      api.reload('1b695ddf', component.options)
    }
    module.hot.accept("./demo_render.vue?vue&type=template&id=1b695ddf&scoped=true", function () {
      api.rerender('1b695ddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_rule/components/demo_render/demo_render.vue"
export default component.exports